export const baseUrl = "https://api.sarayekhiali.ir";
// export const baseUrl = "http://192.168.10.20:8000";
